import React from "react";

import "./active-box.css";

export const ActiveBox = ({
	isActive = true,
	children,
	className,
}: React.PropsWithChildren<{
	isActive?: boolean;
	className?: string;
}>) => (
	<div className={`active-box ${isActive ? "active-box--is-active" : ""} ${className || ""}`}>
		{children}
	</div>
);
ActiveBox.displayName = "ActiveBox";
